// See the HighMediumLow.java

const HighMediumLow = Object.freeze({
  NONE: "NONE",
  LOW: "LOW",
  MEDIUM_LOW: "MEDIUM_LOW",
  MEDIUM: "MEDIUM",
  MEDIUM_HIGH: "MEDIUM_HIGH",
  HIGH: "HIGH",
  VERY_HIGH: "VERY_HIGH",
});
export default HighMediumLow;
